import React from 'react';
import { Grid, Segment, Table } from 'semantic-ui-react';

import { NombrePersonal } from 'src/componentes';
import { AlumnoConAsistencia } from './tipos';

type Props = Readonly<{
    asistencias: readonly AlumnoConAsistencia[];
}>;

export const ListaDeAlumnos = (props: Props) => {
    const { asistencias } = props;

    const presentes = asistencias.filter(a => a.presente).length;
    const ausentes = asistencias.length - presentes;

    return (
        <>
            <Segment attached='top'>
                <Grid columns='equal' textAlign='center'>
                    <Grid.Column>
                        <span style={{ fontWeight: 'bold', color: 'green' }}>
                            Presentes: {presentes}
                        </span>
                    </Grid.Column>

                    <Grid.Column>
                        <span style={{ fontWeight: 'bold', color: 'red' }}>
                            Ausentes: {ausentes}
                        </span>
                    </Grid.Column>

                    <Grid.Column>
                        <span style={{ fontWeight: 'bold' }}>Total: {asistencias.length}</span>
                    </Grid.Column>
                </Grid>
            </Segment>

            <Table compact striped unstackable attached='bottom'>
                <Table.Body>
                    {asistencias.map((asistencia, indice) => (
                        <Fila key={indice} alumno={asistencia} numero={indice + 1} />
                    ))}
                </Table.Body>
            </Table>
        </>
    );
};

const Fila = (props: { alumno: AlumnoConAsistencia; numero: number }) => {
    const { alumno, numero } = props;

    return (
        <Table.Row key={alumno.idAlumno} positive={alumno.presente} negative={!alumno.presente}>
            <Table.Cell width='2'>{numero}</Table.Cell>

            <Table.Cell width='12'>
                <NombrePersonal nombre={alumno.nombre} patron='%P %M %N %S' />
            </Table.Cell>

            <Table.Cell width='2' textAlign='center'>
                <div style={{ fontWeight: 'bold', fontSize: '110%' }}>
                    {alumno.presente ? 'P' : 'A'}
                </div>
            </Table.Cell>
        </Table.Row>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Asistencia/AsistenciaPrevia/ListaDeAlumnos.tsx